import { render } from "./SelectedItems.vue?vue&type=template&id=965d85dc&scoped=true"
import script from "./SelectedItems.vue?vue&type=script&lang=js"
export * from "./SelectedItems.vue?vue&type=script&lang=js"

import "./SelectedItems.vue?vue&type=style&index=0&id=965d85dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965d85dc"]])

export default __exports__